"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyCustomerDataExtraToJSON = exports.ReadonlyCustomerDataExtraFromJSONTyped = exports.ReadonlyCustomerDataExtraFromJSON = void 0;
var runtime_1 = require("../runtime");
function ReadonlyCustomerDataExtraFromJSON(json) {
    return ReadonlyCustomerDataExtraFromJSONTyped(json, false);
}
exports.ReadonlyCustomerDataExtraFromJSON = ReadonlyCustomerDataExtraFromJSON;
function ReadonlyCustomerDataExtraFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kid': !(0, runtime_1.exists)(json, 'kid') ? undefined : json['kid'],
        'bop': !(0, runtime_1.exists)(json, 'bop') ? undefined : json['bop'],
        'ca': !(0, runtime_1.exists)(json, 'ca') ? undefined : json['ca'],
    };
}
exports.ReadonlyCustomerDataExtraFromJSONTyped = ReadonlyCustomerDataExtraFromJSONTyped;
function ReadonlyCustomerDataExtraToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'kid': value.kid,
        'bop': value.bop,
        'ca': value.ca,
    };
}
exports.ReadonlyCustomerDataExtraToJSON = ReadonlyCustomerDataExtraToJSON;
//# sourceMappingURL=ReadonlyCustomerDataExtra.js.map